import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-record/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-record/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-record/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-record/selectPage',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-record/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

export const getWagonOperationPlanPage = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-plan/selectPage',
    method: 'post',
    params
  })
}
